import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f453d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget" }
const _hoisted_2 = {
  key: 0,
  class: "listItem is-small mb-2"
}
const _hoisted_3 = { class: "tag is-white is-rounded is-medium has-text-weight-bold" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip mr-3" }, null, -1))
const _hoisted_6 = { class: "listFilename" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "file has-name is-link is-small pt-2"
}
const _hoisted_11 = { class: "file-label" }
const _hoisted_12 = ["disabled", "multiple"]
const _hoisted_13 = { class: "file-cta" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" })
], -1))
const _hoisted_15 = { class: "file-label" }
const _hoisted_16 = {
  key: 0,
  class: "file-name"
}

import { Core } from "@minicity/core";
import { ref, computed } from "vue";
import { notifyError } from "@/core/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentUploadWidget',
  props: {
    documents: null,
    singleDocument: null,
    readonly: { type: Boolean }
  },
  emits: ["delete", "view", "upload"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'delete', value: Core.Document): void,
    (e: 'view', value: Core.Document): void,
    (e: 'upload', value: {file: File, onDone: ()=>any}): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    documents?: Core.Document[];
    singleDocument?: Core.Document|null;
    readonly?: boolean;
}



const documentToDelete = ref<Core.Document | null>(null);
const uploadInProgress = ref<boolean>(false);

const effectiveDocuments = computed(()=>{
    if (props.documents) return props.documents;
    return props.singleDocument ? [props.singleDocument] : [];
})



const filename = ref<string|null>(null);

const deleteDocument = (doc: Core.Document) => {
    documentToDelete.value = null;
    emit('delete', doc);
}

const viewDocument = (doc: Core.Document) => {
    emit('view', doc);
}

const uploadDocuments = (files: FileList) => {
    let i=0;

    const uploadNextDocument = () => {
        filename.value = `(${i+1}/${files.length}) - ${files[i].name}`;
        uploadInProgress.value = true;

        emit('upload', {
            file: files[i],
            onDone: () => { 
                i++;

                if (i < files.length) {
                    // There are more files
                    if (props.documents != null) {
                        // This is a multi-document upload widget, so we should upload the next file
                        uploadNextDocument();
                    } else {
                        // This is a single-document upload widget, so only one file can be uploaded
                        notifyError("Only one file may be uploaded here");
                    }
                } else {
                    // We're done
                    filename.value = null;
                    uploadInProgress.value = false;
                }
            }
        });
    }

    uploadNextDocument();
}


return (_ctx: any,_cache: any) => {
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (_unref(effectiveDocuments)?.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "None Provided"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(effectiveDocuments), (document) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "listItem mb-2",
            key: document.id
          }, [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("a", {
                onClick: ($event: any) => (viewDocument(document))
              }, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(document.filename), 1)
              ], 8, _hoisted_4)
            ]),
            (!__props.readonly)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: ($event: any) => (documentToDelete.value = document),
                  class: "ml-3 mr-3"
                }, _hoisted_9, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (!__props.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("input", {
                class: "file-input",
                type: "file",
                name: "file",
                disabled: uploadInProgress.value,
                multiple: __props.documents !== undefined,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (uploadDocuments(($event.target as HTMLInputElement).files!)))
              }, null, 40, _hoisted_12),
              _createElementVNode("span", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(uploadInProgress.value ? "Uploading…" : (__props.singleDocument ? "Replace File…" : "Attach File…")), 1)
              ]),
              (filename.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(filename.value), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalDialog, {
      active: documentToDelete.value != null,
      title: "Confirm Delete",
      "allow-close": true,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (documentToDelete.value = null)),
      "first-button-text": "Go Back",
      "first-button-severity": "link",
      onFirstbuttonselected: _cache[2] || (_cache[2] = ($event: any) => (documentToDelete.value = null)),
      "second-button-text": "Delete",
      "second-button-severity": "danger",
      onSecondbuttonselected: _cache[3] || (_cache[3] = ($event: any) => (deleteDocument(documentToDelete.value!)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, "Delete " + _toDisplayString(documentToDelete.value?.filename) + "?", 1)
        ])
      ]),
      _: 1
    }, 8, ["active"])
  ], 64))
}
}

})